import { PORT_IN_ROUTE } from "@api-routes/mnpFacade";
import { getStateToPayload } from "../mappers/deletePortInMapper";
import { useFetch } from "@common/hook/useFetch";

export const useCancelPortIn = (getPortIn: () => void, portInId?: number) => {
    const [cancelPortInState, { deleteCall }] = useFetch();

    const handleCancelPortIn = () => {
        if (portInId) {
            deleteCall<boolean>(PORT_IN_ROUTE, { body: getStateToPayload(portInId) }).then((cancelPortInResponse) => {
                if (cancelPortInResponse) {
                    getPortIn();
                }
            });
        }
    };

    return { cancelPortInState, handleCancelPortIn };
};
